(function() {
  window.medalService = {
    get() {
      return axios.get(`/api/medal/get.php`);
    },
    save(data) {
      return axios.post('/api/medal/save.php', data);
    },
    bits(data) {
      return axios.post('/api/user/medal/bits.php', data);
    },
    getMedals(data) {
      return axios.get(`/api/user/medal/get.php?twitchId=${data && data.twitchId || utils.cookies.get('user_id')}`);
    },
    queue() {
      return axios.get(`/api/user/medal/queue.php`);
    },
    saveMedal(data) {
      return axios.post(`/api/user/medal/save.php`, data);
    },
    deleteMedal(data) {
      return axios.post(`/api/user/medal/delete.php`, {
        id: data.id
      });
    },
    rewardUser(data){
      return axios.post('/api/user/medal/save.php', data);
    },
  }
})();